<template>
  <div class="subscription-plan-view">
    <button role="button" class="button-close" @click="closeView" v-if="isDialogView">
        <img src="/assets/app/class/icon-close.svg">
    </button>
    <div class="plan-view-header" :class="{'with-banner': isBannerVisisbleWithoutTitle}">
      <div class="pricing-table-title" v-if="tableOptions.show_title && !pricingTable">
        <h2 class="view-title">Get ReadTheory for your school</h2>
        <p class="description">Includes all our advanced features for schools, teachers, and students</p>
      </div>
      <div v-if="tableOptions.banner_image_url && !pricingTable" class="pricing-table-title">
        <img class="pricing-custom-banner" :src="tableOptions.banner_image_url">
      </div>
      <!--			<rt-switch-input :priceMode="true" v-model="priceYearly"></rt-switch-input>-->
    </div>
    <div class="plan-view-main">
      <div class="subscription-card" :class="{ 'custom-plan': plansCount <= 3}" 
           v-for="(pricingPlan, pIdx) in subscriptionPlans" :key="pIdx" v-if="isPlanVisible(pricingPlan.type, pIdx)">
        <img class="icon-popular" src="/assets/app/class/icon-popular.svg" v-if="isPopularPlan(pricingPlan.identifier)">
        <div class="subscription-header">
          <img class="plan-icon" :src="pricingPlanIcon(pricingPlan)">
          <h2 class="subscription-title">{{ pricingPlanName(pricingPlan) }}</h2>
        </div>
        <div class="subscription-content"
             :class="{ inifinte: isCustomPlan(pricingPlan.type), 'slide-content': isSliderView }">
          <div class="subscription-price">
            <div class="current-amount-wrapper" v-if="!isCustomPlan(pricingPlan.type)">
              <span class="price-symbol">$</span>
              <span class="amount-value">{{ getAmount(pricingPlan) }}</span>
              <span class="price-symbol">/ {{ planAmountSuffix }}</span>
            </div>
            <img class="icon-infinite" src="/assets/app/class/icon-infinite-rocket.svg" v-else>
          </div>
          <p class="plan-descripion">{{ planDescription(pricingPlan) }}</p>
          <div class="subscription-action"
               :class="{ popular: pricingPlan.identifier === '2' }"
               v-if="!isSliderView">
            <primary-button @click="handleUpgradePlan(pricingPlan)" class="pay-with-card-btn">
              <span class="btn-action-title">{{ pricingActionTitle(pricingPlan.type) }}</span>
              <div class="loading-spinner" v-if="upgradingStatus && upgradingStatus[pricingPlan.identifier]"></div>
              <a class="email-link" href="mailto:support@readtheory.org?subject=Quote%20for%20our%20district"
                 v-if="isCustomPlan(pricingPlan.type)"></a>
            </primary-button>
            <primary-button class="quote-button"
                            v-if="!isFreePlan(pricingPlan.type)"
                            @click="openQuoteForm(pricingPlan)"
                            style="margin-top: 12px;">
              Contact Sales
            </primary-button>
          </div>
          <ul class="features-list">
            <li v-for="(featureDesc, idx) in pricingFeatures(pricingPlan)" :key="idx">
              <img src="/assets/app/class/icon-check-blue.svg">
              <span class="feature-description">{{ featureDesc }}</span>
            </li>
          </ul>
          <div class="subscription-action"
               :class="{ free: isLoggedIn && isFreePlan(pricingPlan.type), popular: pricingPlan.identifier === '2' }"
               v-if="isSliderView">
            <primary-button @click="handleUpgradePlan(pricingPlan)">
              <span class="btn-action-title">{{ pricingActionTitle(pricingPlan.identifier) }}</span>
              <div class="loading-spinner" v-if="upgradingStatus && upgradingStatus[pricingPlan.identifier]"></div>
              <a class="email-link" href="mailto:support@readtheory.org?subject=Quote%20for%20our%20district"
                 v-if="isCustomPlan(pricingPlan.type)"></a>
            </primary-button>
            <p class="yearly-disclaimer" v-if="priceYearly && !isFreePlan(pricingPlan.type)">*when billed annually</p>
          </div>
        </div>
      </div>
    </div>
    <subscription-quote-form v-if="clickedGetQuote" :price-id="currPriceId"/>
  </div>
</template>

<script>

import log from 'common/Logger';
import Toast from 'common/Toast';
import {updateCustomerly} from 'teachers/customerly';
import {updateHubspot} from 'teachers/hubspot';
// import {sendEvent} from 'teachers/sendinblue.js';
import {getUser} from 'common/UserService';
import Story from 'common/Story';
import {createSubscriptionCheckoutSession} from 'common/api';
import RTGoogleAnalyticsManager from 'common/RTGoogleAnalyticsManager';
import PrimaryButton from '../common/PrimaryButton.vue';
import SecondaryButton from '../common/SecondaryButton.vue';
import RtSwitchInput from '../common/RtSwitchInput.vue';
import {constants} from '../../../config';
import Utils from '../../../common/Utils';
import {plans, table_options} from '../../../common/plans';
import _ from 'lodash';
import SubscriptionQuoteForm from './subscription/SubscriptionQuoteForm.vue';
import {loadStripeOnce} from '../../../common/stripe';
import {RTFacebookPixel} from '../../../common/fbpixel';

const PRICING_PLAN_DISTRICT = 'district';
const UPGRADE_LOADING_DURATION = 3000;

export default {
  props: {
    type: String,
    viewType: String,
	pricingTable: Boolean
  },
  components: {
    SubscriptionQuoteForm,
    SecondaryButton,
    PrimaryButton,
    RtSwitchInput,
  },
  computed: {
    isDialogView() {
      return this.viewType === 'dialog';
    },
    priceInterval() {
      return !this.priceYearly ? 'month' : 'year';
    },
    planAmountSuffix() {
      return !this.priceYearly ? 'mo' : 'year';
    },
    isLoggedIn() {
      return !!getUser();
    },
    isBannerVisisbleWithoutTitle() {
      return this.isDialogView && !this.pricingTable && this.tableOptions.banner_image_url && !this.tableOptions.show_title;
    },
    isSliderView() {
      return false;
    },
    sliderStyle() {
      return {
        width: '34px',
        height: '25px',
        background: 'url(/assets/app/class/icon-slider-picker.svg)',
        top: '-10px',
        borderRadius: '12.5px',
      };
    },
    plansCount() {
      return this.isSliderView ? 2 : this.subscriptionPlans.length;
    },
    sliderMaxValue() {
      return this.hasFreePlan ? this.subscriptionPlans.length - 1 : this.subscriptionPlans.length;
    },
  },
  data: function() {
    return {
      priceYearly: true,
      upgradingStatus: null,
      subscriptionPlans: null,
      tableOptions: {},
      hasFreePlan: false,
      clickedGetQuote: false,
      currPriceId: '',
      sliderValue: 0,
    };
  },
  watch: {
    'priceYearly'(newVal) {
      if (this.isDialogView) {
        this.$emit('showView');
      }
    },
  },
  async created() {
    await loadStripeOnce();
  },
  mounted() {
    if (this.type === 'support') {
      if (window.Stripe) {
        window.Stripe = null;
      }
    }
    try {
      this.tableOptions = table_options;
      // this.tableOptions = {
      //   ...table_options,
      //   table_type: 'slider'
      // };
      this.subscriptionPlans = plans;
      this.hasFreePlan = !!(plans.find(plan => plan.type === 'free'));
    } catch (error) {
      log.error(error.message);
      Toast.error(error.message);
    }
  },
  methods: {
    isMobileDevice() {
      return Utils.isMobile() || Utils.isTablet();
    },
    isFreePlan(type) {
      return type === 'free';
    },
    isPopularPlan(identifier) {
      return !this.isSliderView && identifier === '2';
    },
    isCustomPlan(type) {
      return type === 'custom';
    },
    isPlanVisible(type, planIndex) {
      const planNum = this.hasFreePlan ? planIndex : planIndex + 1;
      const isVisible = !this.isSliderView || type === 'free';
      return isVisible;
    },
    pricingPlanIcon(pricingPlan) {
      if (pricingPlan.icon) {
        return pricingPlan.icon;
      }
      let iconSrc = '/assets/app/class/';
      switch (pricingPlan.type) {
        case 'free':
          iconSrc += 'icon-customer.svg';
          break;
        case 'custom':
          iconSrc += 'icon-infinite.svg';
          break;
        default:
          if (pricingPlan.identifier === '3') {
            iconSrc += 'icon-participants.svg';
          } else {
            iconSrc += 'icon-customer-group.svg';
          }
          break;
      }
      return iconSrc;
    },
    pricingPlanName(plan) {
      return plan.name;
    },
    planDescription(plan) {
      let description = plan.description;
      if (!description) {
        switch (plan.type) {
          case 'free':
            description = 'Forever';
            break;
          case 'custom':
            description = 'Unlimited usage';
            break;
          default:
            description = `${plan.numOfClasses} Class${plan.numOfClasses > 1 ? 'es' : ''}, ${plan.numOfClasses * 40} students`;
            break;
        }
      }
      return description;
    },
    pricingActionTitle(type) {
      if (this.isFreePlan(type)) {
        if (this.isLoggedIn) {
          return 'Current Plan';
        } else {
          // return 'Create a free account';
          return 'Try for Free';
        }
      } else {
        if (this.isCustomPlan(type)) {
          return 'Contact Sales';
        } else {
          return 'Pay With Credit Card';
        }
      }
    },
    pricingFeatures(pricingPlan) {
      return pricingPlan.features;
    },
    slidePointStyle(pointIndex) {
      if (pointIndex < this.sliderMaxValue) {
        const percent = (100 / this.subscriptionPlans.length) * pointIndex;
        return `left: calc(${percent}% + 4px)`;
      } else {
        return '';
      }
    },
    getAmount(plan) {
      if (this.isFreePlan(plan.type)) {
        return '0';
      } else {
        return this.priceYearly ?
            plan.prices.price_p_year :
            plan.prices.price_p_month;
      }
      // let amount = 0;
      // if (isDiscount) {
      // 	amount = this.priceInterval === 'year' ?
      // 		subscriptionPlan.prices.price_p_year :
      // 		subscriptionPlan.prices.price_p_month;
      // } else {
      // 	amount = this.priceInterval === 'year' ?
      // 		subscriptionPlan.prices.price_p_year_crossed :
      // 		subscriptionPlan.prices.price_p_month_crossed;
      // }

      // return `$${amount}/month${this.priceInterval == 'year' ? '*' : ''}`;
    },
    getNumOfClasses(identifier) {
      if (identifier === PRICING_PLAN_DISTRICT) {
        return '&infin;';
      }

      return this.findSubscriptionPlan(identifier).numOfClasses;
    },
    findSubscriptionPlan(identifier) {
      const subscriptionPlan = this.subscriptionPlans.find(plan => plan.identifier === identifier);
      return subscriptionPlan;
    },
    async checkoutSubscription(priceId, couponId) {
      const isDevEnv = process.env.NODE_ENV !== 'production';
      const url = new URL(window.location.href);
      url.searchParams.set('sub', 'success');
      const successUrl = url.toString().replaceAll('&', encodeURIComponent('&'));
      url.searchParams.set('sub', 'failed');
      const cancelUrl = url.toString().replaceAll('&', encodeURIComponent('&'));


      // let successUrl = `${constants.domainPrefix}/app/teacher/class/list?sub=success`;
      // let cancelUrl = `${constants.domainPrefix}/app/teacher/class/list?sub=failed`;
      const urlParams = Utils.getUrlParams();
      let email = urlParams['email'];
      const user = getUser();
      if (_.isEmpty(email)) {
        email = user?.email;
      }
      const campaign = urlParams['campaign'] || urlParams['utm_campaign'] || localStorage.getItem('rt_sub_campaign')
      const sessionResult = await createSubscriptionCheckoutSession(email, priceId, successUrl, cancelUrl, couponId, user?.id, null, null, campaign);

      if (sessionResult.success) {
        const checkoutSession = sessionResult.response;
        if (!checkoutSession) return;
        if (checkoutSession.error) {
          this.upgradingStatus = null;
          if (!this.isMobileDevice()) {
            log.error(checkoutSession.error.message);
          }
          Toast.error(checkoutSession.error.message);
        } else {
          if (!checkoutSession.id) {
            Toast.error('Something went wrong');
            return;
          }

          const stripe = Stripe(constants.stripePublicKey);
          /*
          * When the customer clicks on the button, redirect
          * them to Checkout.
          */
          stripe.redirectToCheckout({
            sessionId: checkoutSession.id,
          })
              .then(function(result) {
                if (result.error) {
                  /*
                  * If `redirectToCheckout` fails due to a browser or network
                  * error, display the localized error message to your customer.
                  */
                  this.upgradingStatus = null;
                  if (!this.isMobileDevice()) {
                    log.error(result.error.message);
                  }
                  Toast.error(result.error.message);
                } else {
                  this.$emit('pricingChanged');
                }
              });
        }
      } else {
        this.upgradingStatus = null;
        if (!this.isMobileDevice()) {
          log.error(sessionResult.message);
        }
        Toast.error(sessionResult.error.message);
      }
    },
    closeView() {
      this.upgradingStatus = null;
      if (this.isDialogView) {
        this.$emit('closeView');
      }
    },
    openQuoteForm(pricingPlan) {
      this.currPriceId = pricingPlan.prices['stripe_p_' + this.priceInterval + '_price_id'];
      // this.clickedGetQuote = false;
      window.open('/get-in-touch?utm_source=in_app&utm_medium=pricing_table&utm_campaign=quote', '_blank');
      // window.scrollTo({
      //   top: 985,
      //   left: 0,
      //   behavior: 'smooth',
      // });
    },
    handleUpgradePlan(pricingPlan) {
      if (pricingPlan.type === 'free') {
        if (this.isLoggedIn) {
		  this.$emit('freePlanSelected');
		  return;
        } else {
          this.$router.push('/app/sign-up/role?ref=school');
          return;
        }
      }
      const planIdentifier = pricingPlan.identifier;
      const subscriptionPlan = pricingPlan;
      const pricingId = subscriptionPlan.prices['stripe_p_' + this.priceInterval + '_price_id'];
      const couponId = subscriptionPlan.prices['stripe_p_' + this.priceInterval + '_coupon_id'];
      const pricingName = subscriptionPlan.name;
      const priceInterval = this.priceInterval;
      let price = this.getAmount(pricingPlan);
      const extraFields = {
        param1: pricingId,
        param2: planIdentifier,
        param3: price,
        params4: priceInterval,
      };

      try {
        // send events for analyzation

        Story.addStep('clicked_plan', extraFields);
        RTFacebookPixel.reportAddPaymentInfoEvent();
        RTGoogleAnalyticsManager.sendEvent(pricingName, 'clicked_plan', pricingPlan);

      } catch (e) {
        if (!this.isMobileDevice()) {
          log.error(e);
        }
      }

      let newUpgradingStatus = {
        [planIdentifier]: true,
      };
      if (planIdentifier !== PRICING_PLAN_DISTRICT) {
        if (subscriptionPlan) {
          this.checkoutSubscription(pricingId, couponId);
        } else {
          newUpgradingStatus = null;
        }
      }
      this.upgradingStatus = newUpgradingStatus;
      setTimeout(() => {
        this.closeView();
      }, UPGRADE_LOADING_DURATION);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../common/variables';

.pricing-table-title {
  text-align: center;

  .pricing-custom-banner {
    max-width: 100%;
    height: auto;
    margin-bottom: 10px;
  }
}

.quote-button {
  background: #edf3fe;
  color: #3882fd;
}

.quote-button:hover {
  color: white;
}

.subscription-plan-view {
  position: relative;
  h2 {
    margin: 0;
    line-height: 1;
    color: $title-dark-grey;
  }

  p {
    margin: 0;
    line-height: 1;
    color: $title-grey;
  }

  .plan-view-header {
    position: relative;
    &.with-banner {
      padding-top: 3rem;
    }

    .view-title {
      font-size: 36px;
      text-align: center;
      font-family: $title-font;
    }

    .description {
      padding: 16px 0;
      font-size: 16px;
      text-align: center;
    }   
  }

  .button-close {
    position: absolute;
    top: 10px;
    right: 0;
    border: 0;
    background: transparent;
    font-weight: bold;
    font-size: 18px;
    color: #555;
    cursor: pointer;
    z-index: 1;

    &:hover {
      opacity: 0.8;
    }
  }

  .plan-view-main {
    display: flex;
    justify-content: center;
    padding-top: 32px;

    .subscription-card {
      width: 268px;
      background: white;
      padding: 40px 32px 32px;
      margin-right: 20px;
      border-radius: 22px;
      box-shadow: 0px 4px 32px rgba(0, 0, 0, 0.08), 0px 4px 8px rgba(191, 197, 208, 0.22);
      position: relative;

      &:last-child {
        margin-right: 0;
      }

      &.custom-plan {
        width: 370px;
      }

      .icon-popular {
        position: absolute;
        top: 0;
        right: 0;
      }

      .subscription-header {
        display: flex;
        align-items: center;
        justify-content: center;

        .subscription-class-count {
          justify-content: center;

          .class-count {
            position: absolute;
            left: 50%;
            top: 45%;
            transform: translate(-50%, -50%);
            font-size: 20px;
            font-weight: 700;
            color: $light-red;

            &.infine {
              top: 42%;
              font-size: 26px;
            }
          }
        }

        .plan-icon {
          margin-right: 8px;
        }

        .subscription-title {
          text-transform: uppercase;
          font-weight: 700;
          font-size: 16px;
          color: $title-dark-grey;
        }
      }

      .subscription-content {
        padding-top: 50px;

        &.inifinte {
          padding-top: 32px;
        }

        .subscription-price {
          font-size: 12px;
          text-align: center;

          .discount-amount {
            color: #818A96;
            text-decoration: line-through;

            &.district {
              text-decoration: none;
            }
          }

          .current-amount-wrapper {
            display: flex;
            align-items: center;
            width: fit-content;
            margin: 0 auto;

            .price-symbol {
              font-size: 18px;
              color: $light-blue2;
            }

            .amount-value {
              margin: 0 8px;
              line-height: 1;
              font-size: 56px;
              font-weight: 600;
              color: $light-blue2;
              font-family: $title-font;
            }
          }

          .icon-infinite {
            margin: 0 auto;
          }
        }

        .plan-descripion {
          padding-top: 8px;
          text-align: center;
          font-weight: 700;
          font-size: 16px;
          color: $title-dark-grey;
        }

        .slider-wrapper {
          margin-top: 20px;
          position: relative;

          .slide-point {
            position: absolute;
            top: 6px;
            width: 10px;
            height: 10px;
            background: #7FADF9;
            border-radius: 50%;
            pointer-events: none;

            &:last-child {
              left: calc(100% - 14px);
            }
          }
        }

        .features-list {
          margin-top: 25px;
          list-style: none;

          li {
            display: flex;
            padding-top: 20px;

            img {
              height: 16px;
            }

            .feature-description {
              margin-left: 12px;
              font-size: 14px;
              color: $title-grey;
            }
          }
        }

        &.slide-content {
          display: flex;
          flex-direction: column;
          height: calc(100% - 16px);

          .subscription-action {
            flex: 1;
            min-height: 0;
            display: flex;
            align-items: flex-end;
            padding-top: 70px;
          }
        }
      }

      .subscription-action {
        padding-top: 24px;
        text-align: center;

        .primary-button {
          position: relative;
          width: 100%;
          margin: 0 auto;
          padding: 16px;
          background: #EDF3FE;
          border: 0;
          border-radius: 30px;

          .btn-action-title {
            font-weight: 700;
            font-size: 14px;
            color: $light-blue2;
          }

          .loading-spinner {
            position: absolute;
            right: 7px;
            top: 6px;
          }

          .email-link {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
          }

          &:hover {
            background: $light-blue2;

            .btn-action-title {
              color: #fff;
            }
          }
        }

        &.free {
          .primary-button {
            pointer-events: none;
          }
        }


        &:not(.free) {
          &.popular {
            .primary-button.pay-with-card-btn {
              background: $light-blue2;

              .btn-action-title {
                color: #fff;
              }
            }
          }

          &.popular {
            .primary-button {
              //border: 2px solid $title-dark-grey;
            }
          }
        }
      }
    }
  }

  .yearly-disclaimer {
    text-align: center;
    font-weight: bold;
    margin-top: 10px;
    display: block;
  }
}
</style>
